// extracted by mini-css-extract-plugin
module.exports = {"container":"Localities_container__1EiOi","carrouselMode":"Localities_carrouselMode__HAnmM"};